import { Button, Grid } from '@mui/material';
import ViewMessageSyncUpStyles from './ViewMessageSyncUp.styles';

interface Props {
	onClose(): void;
	errorResponse: boolean;
	dataResponse: any;
}

const ViewMessageSyncUp: React.FC<Props> = ({ onClose, errorResponse, dataResponse }) => {
	const classes = ViewMessageSyncUpStyles();
	return (
		<>
			{errorResponse ? (
				<div className={classes.root}>
					<div className={classes.rootC} />
					<section className={classes.card}>
						<Grid container spacing={1}>
							<Grid item xs={12}>
								<h5 className={classes.tittle}>
									Este rango de guías ya se
									<br />
									encuentra o se cruza en TEST.
								</h5>
							</Grid>
						</Grid>
						<Grid container spacing={1}>
							<Grid
								style={{
									marginTop: '1px',
									marginLeft: '9px',
									marginBottom: '12px',
								}}
								item
								xs={12}
							>
								<table>
									<thead>
										<tr>
											<th className={classes.tittleTable}>Identificación</th>
											<th
												style={{ padding: '0px 0px 0px 30px' }}
												className={classes.tittleTable}
											>
												DIV
											</th>
											<th
												style={{ padding: '0px 0px 0px 50px' }}
												className={classes.tittleTable}
											>
												ID Rango
											</th>
										</tr>
									</thead>

									<tbody>
										<tr>
											<td className={classes.texto}>
												{dataResponse.identificacion}
											</td>
											<td
												style={{ padding: '0px 0px 0px 30px' }}
												className={classes.texto}
											>
												{dataResponse.codigo_div}
											</td>
											<td
												style={{ padding: '0px 0px 0px 50px' }}
												className={classes.texto}
											>
												{dataResponse.id_rango}
											</td>
										</tr>
									</tbody>
								</table>
							</Grid>
						</Grid>
						<Grid container spacing={1}>
							<Grid
								style={{ marginTop: '1%', marginLeft: '53%', marginBottom: '20px' }}
								item
								xs={12}
							>
								<Button
									onClick={onClose}
									className={classes.button}
									variant="contained"
								>
									CERRAR
								</Button>
							</Grid>
						</Grid>
					</section>
				</div>
			) : (
				<div className={classes.root}>
					<div className={classes.rootC} />
					<section style={{ width: 346, height: 130 }} className={classes.card}>
						<Grid container spacing={1}>
							<Grid item xs={12}>
								<h5 className={classes.tittle}>
									Este rango de guías ha sido
									<br />
									sincronizado a TEST exitosamente
								</h5>
							</Grid>
						</Grid>
						<Grid container spacing={1}>
							<Grid
								style={{ marginTop: '1%', marginLeft: '52%', marginBottom: '20px' }}
								item
								xs={12}
							>
								<Button
									onClick={onClose}
									className={classes.button}
									variant="contained"
								>
									CERRAR
								</Button>
							</Grid>
						</Grid>
					</section>
				</div>
			)}
		</>
	);
};

export default ViewMessageSyncUp;
